/**
 * Application config
 * import { config } from './app.config';
 */
var app = {
  /**
   * Define request error code
   * config success, error
   */
  status: {
    s_200: 200,
    s_201: 201,
    s_202: 202,
    s_203: 203,
    s_204: 204,
    s_205: 205,
    s_500: 500
  },
  deferred: false,
  build_as_takeout: true, // true 店外
  version: 'v2.1.3',
  /**
   * record_status
   */
  record_status: {
    A: 'A', //Active
    I: 'I' //Deactive
  },
  did: 'localhost', // for test
  mobile_pay_url: 'https://www.okagego.com/linepay/',
  //service: 'https://api.okageregi.com/vstg/smart/api/',
  //service: 'https://api.okageregi.com/v2.28.9/smart/api/',
  service: 'https://api.okagego.com/v31/smart/api/',
  //service: 'https://api.okageregi.com/vkimtest/smart/api/',
  //service: 'https://api.okageregi.com/v2.28.2/smart/api/',
  //service: 'https://api.okage-test.com/vdev/smart/api/',
  //service: 'https://pre-api.okagego.com/v31dev/smart/api/',

  // soeweb1
  //service: 'http://52.196.2.172/vkimtest/smart/api/',

  // soeweb3
  //service: 'http://13.231.20.235/vkimtest/smart/api/',
  
  // soeweb4
  //service: 'http://52.199.253.157/vkimtest/smart/api/',

  // soeweb7 3.112.249.24
  //service: 'http://3.112.249.24/vkimtest/smart/api/',


  linepay_service: 'http://192.168.100.35:5000/',
  linepay_callback_url: 'http://192.168.100.35:8081/',
  // linepay_callback_url: 'http://192.168.100.35:5000/confirm',
  uiid: 'test_uiid',
  table_id: 1,
  category: {
    food: 3,
    drink: 4,
    other: 5
  },
  tab_menu_number: {
    menulayoutspage: 0,
    menulistpage: 1,
    recommendpage: 2,
    orderhistorypage: 3,
    sendorderpage: 4,
    loginpage: 5,
  },
  okage_tracking_id: 'UA-88910384-1', // okage全体用
  //okage_tracking_id: 'UA-176412458-1',
  error_report_endpoint: 'https://api.okageregi.com/v2.28.9/applogs/okagego.php'
};
export const config = app;
export const Config = app;
export const AppConfig = app;


// WEBPACK FOOTER //
// ./src/app/app.config.ts